import { createAction, props } from '@ngrx/store';

import { AccountState } from '../states/account.state';

export const set = createAction('[Account] set', props<{ payload: AccountState }>());
